import { render, staticRenderFns } from "./InstanceReviewQueue.vue?vue&type=template&id=2771d0c8&scoped=true&"
import script from "./InstanceReviewQueue.vue?vue&type=script&lang=js&"
export * from "./InstanceReviewQueue.vue?vue&type=script&lang=js&"
import style0 from "./InstanceReviewQueue.vue?vue&type=style&index=0&id=2771d0c8&prod&scoped=true&lang=css&"
import style1 from "./InstanceReviewQueue.vue?vue&type=style&index=1&id=2771d0c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771d0c8",
  null
  
)

export default component.exports